// Librerías
import React, { useState, useEffect } from "react";
import { ScreenClassProvider } from "react-grid-system";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";
import ReactGA from "react-ga";
// Components
import Navbar from "../components/Navbar/Navbar";
import PropertyComponent from "../components/PropertyPage/PropertyComponent";
import Footer from "../components/Footer/Footer";
import SEOHead from "../components/PropertyPage/SEOHead"; // ✅ Nuevo import
import PropertyGallerySkeleton from "../components/PropertyPage/Utils/PropertyGallerySkeleton";
import PropertyInfoSkeleton from "../components/PropertyPage/Utils/PropertyInfoSkeleton";
import PropertyBookingSkeleton from "../components/PropertyPage/Utils/PropertyBookingSkeleton";
// Recursos
import "../assets/styles/PropertyPage/_property_page.sass";
import { BASE_URL } from "../Helpers";

ReactGA.initialize("G-H6XXNZ6Z0T");

const PropertyPage = () => {
  const [images, setImages] = useState([]);
  const [video, setVideo] = useState({});
  const [housing, setHousing] = useState(false);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const query = queryString.parse(window.location.search);
  const { partner } = query;

  const sendAndSaveMarketingLog = (partner) => {
    localStorage.setItem("partner", JSON.stringify(partner));
    const url = BASE_URL + "/housing/marketing/";
    const bodyParameters = {
      action: "view",
      partner: partner,
      reservation: null,
      housing: id,
    };
    axios.post(url, bodyParameters).catch(function (error) {
      console.log(error.response);
    });
  };

  const getImage = () => {
    const url_media = BASE_URL + "/housing/images/" + id;
    return axios // ✅ Return promise para Promise.all
      .get(url_media)
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            response.data.forEach((img) => {
              img.media = BASE_URL + img.media.replace("public", "");
            });
            setVideo(response.data[0]);
            response.data.splice(0, 1);
            setImages(response.data);
          }
        }
      })
      .catch(function (error) {
        console.log(error.response);
      });
  };

  // Keep this effect keyed to route id to avoid duplicate fetches while preserving current flow.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    localStorage.removeItem("partner");
    setLoading(true);
    const apiKey = process.env.REACT_APP_ALOHAR_KEY;
    const url = `${BASE_URL}/housing/${id}?apiKey=${apiKey}`;
    
    const fetchHousing = axios.get(url).then(function (response) {
      if (response.status === 200) {
        response.data.housingService = response.data.housingService.map(
          (service) => service.housingService
        );
        response.data.housingRoom = response.data.housingRoom.map(
          (room) => room.room
        );
        response.data.housingRule = response.data.housingRule.map(
          (rule) => rule.rule
        );
        setHousing(response.data);
        
        // ✅ Google Analytics tracking con datos de la propiedad
        ReactGA.pageview(`/property/${id}`, null, `${response.data.title} - ${response.data.location?.location}`);
      }
    });
    
    const fetchImages = getImage();
    
    Promise.all([fetchHousing, fetchImages])
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
      
    if (partner) {
      sendAndSaveMarketingLog(partner);
    }
  }, [id]);

  return (
    <ScreenClassProvider>
      <SEOHead
        housing={housing}
        images={images}
      />
      <Navbar addSearch={true} />
      <div className="PropertyPage">
        {loading ? (
          <div className="PropertyPage__loading">
            <PropertyGallerySkeleton />
            <div className="PropertyPage__content">
              <PropertyInfoSkeleton />
              <PropertyBookingSkeleton />
            </div>
          </div>
        ) : housing ? (
          <PropertyComponent images={images} video={video} housing={housing} />
        ) : (
          <div>No se pudo cargar la propiedad</div>
        )}
      </div>
      <Footer />
    </ScreenClassProvider>
  );
};

export default connect()(PropertyPage);
